import { config } from '@/config'

import { AnalyticsBrowser } from '@segment/analytics-next'
import { useMemo } from 'react'

let analyticsInstance: AnalyticsBrowser | null = null

if (!config.segmentId) {
  console.warn('Segment analytics not initialized: missing segmentId in config')
}

const mockAnalytics = ({
  track: () => Promise.resolve(),
  identify: () => Promise.resolve(),
  page: () => Promise.resolve(),
  group: () => Promise.resolve(),
} as unknown) as AnalyticsBrowser

const initializeAnalytics = (): AnalyticsBrowser => {
  if (!config.segmentId) {
    return mockAnalytics
  }

  if (!analyticsInstance) {
    try {
      analyticsInstance = AnalyticsBrowser.load({ writeKey: config.segmentId })
    } catch (error) {
      console.warn('Failed to initialize Segment analytics:', error)
      return mockAnalytics
    }
  }

  return analyticsInstance
}

export const useSegment = () => {
  const analytics = useMemo(() => initializeAnalytics(), [])

  return analytics
}
